const CONTACT_EMAIL = 'me@mateusemth.dev';
const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('Contato - Monitor Fiscal')}`;

export {
  CONTACT_EMAIL,
  CONTACT_MAILTO
};
